"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANNUAL_MOTOR_ADD_DRIVER_LIMIT = exports.ANNUAL_MOTOR_ADDRESS_CHANGE_LIMIT = exports.ANNUAL_MOTOR_VRN_CHANGE_LIMIT = exports.ANNUAL_MOTOR_REPLACE_CAR_LIMIT = exports.ANNUAL_MOTOR_TOTAL_MTA_LIMIT = void 0;
exports.ANNUAL_MOTOR_TOTAL_MTA_LIMIT = 8;
exports.ANNUAL_MOTOR_REPLACE_CAR_LIMIT = 4;
exports.ANNUAL_MOTOR_VRN_CHANGE_LIMIT = 2;
exports.ANNUAL_MOTOR_ADDRESS_CHANGE_LIMIT = 2;
exports.ANNUAL_MOTOR_ADD_DRIVER_LIMIT = 4;
//# sourceMappingURL=mtaLimitConstants.js.map